import Hero from "@/components/Hero";
import ServicesGrid from "@/components/ServicesGrid";
import CitiesGrid from "@/components/CitiesGrid";
import BeforeAfter from "@/components/BeforeAfter";
import QualityCommitments from "@/components/QualityCommitments";
import Faq from "@/components/Faq";
import QuoteForm from "@/components/QuoteForm";
import ProcessSection from "@/components/ProcessSection";
import CtaBanner from "@/components/CtaBanner";
import SeoHead, { localBusinessJsonLd, faqJsonLd } from "@/components/SeoHead";
import { FAQ_GENERAL } from "@/data/siteData";

export default function Home() {
  const jsonLd = [localBusinessJsonLd(), faqJsonLd(FAQ_GENERAL)];

  return (
    <>
      <SeoHead
        title="Dégraissage Hotte Melun — Nettoyage Hotte Restaurant & Extraction Cuisine Seine-et-Marne"
        description="Dégraissage hotte Melun et Seine-et-Marne (77). Nettoyage hotte professionnelle, extraction cuisine, gaines de ventilation. Intervention 7j/7, attestation officielle. ☎ 07 64 15 38 77."
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <Hero
        eyebrow="Spécialiste Seine-et-Marne · 7j/7"
      />
      <ServicesGrid
        subtitle="Nous nettoyons hottes, gaines, extractions et cuisines de restaurants, brasseries, boulangeries, hôtels et collectivités. Service complet avec attestation officielle."
      />
      <ProcessSection />
      <BeforeAfter />
      <CtaBanner />
      <CitiesGrid />
      <QualityCommitments />
      <Faq items={FAQ_GENERAL} />
      <QuoteForm />
    </>
  );
}
